import { reactive, readonly } from 'vue';

type FieldPresetsModalConfig = {
  feedId: number | null;
  sourceId: number | undefined;
  presetId: number | undefined;
  isForPartner: boolean;
  onSuccess?: (presetId: number, isNewPreset: boolean) => void;
};

type FieldPresetsModalState = {
  isVisible: boolean;
  config: FieldPresetsModalConfig;
};

const state = reactive<FieldPresetsModalState>({
  isVisible: false,
  config: {
    feedId: null,
    sourceId: undefined,
    presetId: undefined,
    isForPartner: false,
    onSuccess: undefined,
  },
});

export function useFieldPresetsModal() {
  function openModal(options: {
    feedId: number;
    sourceId?: number;
    presetId?: number;
    isForPartner?: boolean;
    onSuccess?: (presetId: number, isNewPreset: boolean) => void;
  }) {
    state.config = {
      feedId: options.feedId,
      sourceId: options.sourceId,
      presetId: options.presetId,
      isForPartner: options.isForPartner ?? false,
      onSuccess: options.onSuccess,
    };
    state.isVisible = true;
  }

  function closeModal() {
    state.isVisible = false;
  }

  return {
    state: readonly(state),
    openModal,
    closeModal,
  };
}
